module.exports = __webpack_public_path__ + "img/1923.781e16e4.png";